import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "Bussiness",
    path: `${APP_PREFIX_PATH}/bussiness/bussiness`,
    component: React.lazy(() => import("views/app-views/List/Bussiness")),
  },
  {
    key: "add-bussiness",
    path: `${APP_PREFIX_PATH}/bussiness/add-bussiness`,
    component: React.lazy(() => import("views/app-views/List/AddBusiness")),
  },
  {
    key: "project",
    path: `${APP_PREFIX_PATH}/project/project`,
    component: React.lazy(() => import("views/app-views/List/Project")),
  },
  {
    key: "add-project",
    path: `${APP_PREFIX_PATH}/project/add-project`,
    component: React.lazy(() => import("views/app-views/List/AddProject")),
  },
  {
    key: "Product",
    path: `${APP_PREFIX_PATH}/product/product`,
    component: React.lazy(() => import("views/app-views/List/Product")),
  },
  {
    key: "Product",
    path: `${APP_PREFIX_PATH}/product/add-product`,
    component: React.lazy(() => import("views/app-views/List/AddProduct")),
  },
  {
    key: "Services",
    path: `${APP_PREFIX_PATH}/services/services`,
    component: React.lazy(() => import("views/app-views/List/Service")),
  },
  {
    key: "Services",
    path: `${APP_PREFIX_PATH}/service/add-service`,
    component: React.lazy(() => import("views/app-views/List/AddService")),
  },
  {
    key: "user",
    path: `${APP_PREFIX_PATH}/user/user`,
    component: React.lazy(() => import("views/app-views/List/UserList")),
  },
  {
    key: "add-user",
    path: `${APP_PREFIX_PATH}/user/add-user`,
    component: React.lazy(() => import("views/app-views/List/AddUser")),
  },
  {
    key: "Category",
    path: `${APP_PREFIX_PATH}/Category/CategoryList`,
    component: React.lazy(() => import("views/app-views/DropDown/Category")),
  },
  {
    key: "mainCategory",
    path: `${APP_PREFIX_PATH}/Category/add-maincategory`,
    component: React.lazy(() => import("views/app-views/DropDown/AddCategory")),
  },
  {
    key: "SubCategory",
    path: `${APP_PREFIX_PATH}/SubCategory/SubCategory`,
    component: React.lazy(() => import("views/app-views/DropDown/SubCategory")),
  },
  {
    key: "SubCategoryadd",
    path: `${APP_PREFIX_PATH}/SubCategory/add-SubCategory`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/AddSubCategory")
    ),
  },
  {
    key: "SubCategoryedit",
    path: `${APP_PREFIX_PATH}/SubCategory/edit-SubCategory`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/EditSubCategory")
    ),
  },
  {
    key: "Specification",
    path: `${APP_PREFIX_PATH}/Specification`,
    component: React.lazy(() => import("views/app-views/DropDown/OtherSpec")),
  },
  {
    key: "add-specification",
    path: `${APP_PREFIX_PATH}/add-specification`,
    component: React.lazy(() =>
      import("views/app-views/DropDown/AddOtherSpec")
    ),
  },
  {
    key: "user",
    path: `${APP_PREFIX_PATH}/static-images`,
    component: React.lazy(() => import("views/app-views/List/ImagesList")),
  },
  {
    key: "add-user",
    path: `${APP_PREFIX_PATH}/add-static-image`,
    component: React.lazy(() => import("views/app-views/List/AddStaticImage")),
  },
  {
    key: "bus-report",
    path: `${APP_PREFIX_PATH}/business-reports`,
    component: React.lazy(() => import("views/app-views/List/BusinessReports")),
  },
  {
    key: "bus-report-details",
    path: `${APP_PREFIX_PATH}/business-reports-details`,
    component: React.lazy(() =>
      import("views/app-views/List/BusinessReportDetails")
    ),
  },
  {
    key: "bus-delete",
    path: `${APP_PREFIX_PATH}/business-delete`,
    component: React.lazy(() => import("views/app-views/List/BusinessDelete")),
  },
  {
    key: "bus-delete-details",
    path: `${APP_PREFIX_PATH}/business-delete-details`,
    component: React.lazy(() =>
      import("views/app-views/List/BusinessDeleteDetails")
    ),
  },
  {
    key: "notification",
    path: `${APP_PREFIX_PATH}/notification`,
    component: React.lazy(() => import("views/app-views/List/Notifications")),
  },
];
